import { Vector2 } from "@react-three/fiber";

export default function dist(in1: Vector2, in2: Vector2) {
  return Math.sqrt(Math.pow(in1.x - in2.x, 2) + Math.pow(in1.y - in2.y, 2));
}
